exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-title[data-v-4cbc5ba3]{font-weight:600;text-decoration:none;cursor:pointer;color:#000!important}span[data-v-4cbc5ba3]{vertical-align:middle}.back-arrow[data-v-4cbc5ba3]{float:left;top:2px}.version[data-v-4cbc5ba3]{float:right;font-size:10px;text-decoration:none;color:grey!important}.footer[data-v-4cbc5ba3]{padding-left:20px;padding-right:20px;position:fixed;bottom:0;width:100%;min-height:4em;background-color:#f0f0f0;height:100px;line-height:100px;text-align:center;z-index:999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4cbc5ba3","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/FooterCheckout.vue
// module id = 398
// module chunks = 0